import { atom } from 'jotai'

export const earnDetailsBreadcrumbAtom = atom<string>('')
earnDetailsBreadcrumbAtom.debugLabel = 'earn-details-breadcrumb'
